import type { GuideQuestDefinition } from "./types.js";

export type GuideQuestHighlightTarget =
  | { readonly kind: "moduleGrid" }
  | { readonly kind: "hudChapter" }
  | { readonly kind: "tab"; readonly tabId: string }
  | { readonly kind: "statUpgradeAction" }
  | { readonly kind: "shopAction" }
  | { readonly kind: "guideQuestAction" };

export type GuideQuestHighlightSource = Pick<
  GuideQuestDefinition,
  "objectiveKind" | "objectiveTarget"
>;

export function resolveGuideQuestHighlightTarget(
  quest: GuideQuestHighlightSource,
): GuideQuestHighlightTarget {
  switch (quest.objectiveKind) {
    case "modulePlaced":
      return { kind: "moduleGrid" };
    case "chapterReached":
      return { kind: "hudChapter" };
    case "tabEntered":
      return { kind: "tab", tabId: quest.objectiveTarget === "any" ? "battle" : quest.objectiveTarget };
    case "upgradeBought":
      return upgradeHighlightTarget(quest.objectiveTarget);
    case "actionCompleted":
      return actionCompletedHighlightTarget(quest.objectiveTarget);
    case "rewardClaimed":
      return { kind: "guideQuestAction" };
  }
}

function upgradeHighlightTarget(target: string): GuideQuestHighlightTarget {
  switch (target) {
    case "rebirth":
    case "moduleMastery":
    case "moduleMerge":
      return { kind: "tab", tabId: target };
    case "module":
      return { kind: "tab", tabId: "moduleMastery" };
    case "stat":
    case "statUpgrade":
    case "any":
    default:
      return { kind: "statUpgradeAction" };
  }
}

function actionCompletedHighlightTarget(target: string): GuideQuestHighlightTarget {
  switch (target) {
    case "shop.goldBox":
    case "shop.goldBox10":
    case "shop.diamondBox":
      return { kind: "shopAction" };
    default:
      return { kind: "tab", tabId: actionTargetTab(target) };
  }
}

function actionTargetTab(target: string): string {
  switch (target) {
    case "shop.goldBox":
    case "shop.goldBox10":
    case "shop.diamondBox":
    case "dailyShop.buy":
      return "shop";
    case "statUpgrade.buy":
      return "statUpgrade";
    case "module.merge":
      return "moduleMerge";
    case "mastery.branchSelect":
      return "moduleMastery";
    case "rebirth.perform":
    case "rebirth.upgrade":
      return "rebirth";
    case "relic.acquire":
      return "relic";
    case "dungeon.challenge":
    case "dungeon.clear":
      return "dungeon";
    case "any":
    default:
      return "battle";
  }
}
